import React from 'react'
import Skeleton from 'react-loading-skeleton'
import Button from '../components/Button';
import { Link } from 'react-router-dom';

const Formulare = ({ formulare }) => {
    const truncateBlocks = (blocks, maxLength = 120) => {
        if (!blocks) return "";

        let text = "";

        for (let block of blocks) {
            if (block.children) {
                for (let child of block.children) {
                    text += child.text;

                    if (text.length >= maxLength) {
                        return text.slice(0, maxLength) + "...";
                    }
                }
            }
        }

        return text;
    };
    return (
        <div className='row dokumente_slider pt-4'>
            {formulare?.map((item, index) => (
                <div className='col-sm-6 col-lg-4 col-item' key={index}>
                    {item?.Komponente === "Page" ? (
                        <Link to={`/${item?.slug}`} className='item_inner'>
                            <img src={`https://backend.bgzurlinden.ch${item?.icon?.url}`} className='icon-size' alt='#' />

                            {item?.Komponente === "Page" ? (
                                <h4 className="text-darkgrey fw-550">{item?.Bannerbereich[0]?.Titel}</h4>
                            ) : (
                                <h4 className="text-darkgrey fw-550">{item?.Titel}</h4>
                            )}

                            {item?.Komponente === "Page" ? (
                                Array.isArray(item.Bannerbereich[0]?.Beschreibung) ? (
                                    <p>{truncateBlocks(item.Bannerbereich[0]?.Beschreibung, 90)}</p>
                                ) : (
                                    <p>
                                        {item?.Bannerbereich[0]?.Beschreibung?.length > 100
                                            ? item.Bannerbereich[0].Beschreibung.slice(0, 100) + "..."
                                            : item?.Bannerbereich[0]?.Beschreibung}
                                    </p>
                                )
                            ) : (
                                <p>
                                    {item?.Text?.length > 100
                                        ? item.Text.slice(0, 100) + "..."
                                        : item?.Text}
                                </p>
                            )}

                            <div className='btn-container'>
                                <div className='simple-arrow-btn'>
                                    zur Anmeldung
                                    <span className='ani_arrows'>
                                        <span className='arrow_arrow'><svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                            <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                                        </svg></span>
                                        <span className='arrow_arrow'><svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                            <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                                        </svg></span>
                                    </span>
                                </div>
                            </div>
                        </Link>
                    ) : item?.Komponente === "Button" ? (
                        <Link to={`${item?.Button[0]?.button_link}`} className='item_inner'>
                            <img src={`https://backend.bgzurlinden.ch${item?.icon?.url}`} className='icon-size' alt='#' />

                            {item?.Komponente === "Page" ? (
                                <h4 className="text-darkgrey fw-550">{item?.Bannerbereich[0]?.Titel}</h4>
                            ) : (
                                <h4 className="text-darkgrey fw-550">{item?.Titel}</h4>
                            )}

                            {item?.Komponente === "Page" ? (
                                Array.isArray(item.Bannerbereich[0]?.Beschreibung) ? (
                                    <p>{truncateBlocks(item.Bannerbereich[0]?.Beschreibung, 90)}</p>
                                ) : (
                                    <p>
                                        {item?.Bannerbereich[0]?.Beschreibung?.length > 100
                                            ? item.Bannerbereich[0].Beschreibung.slice(0, 100) + "..."
                                            : item?.Bannerbereich[0]?.Beschreibung}
                                    </p>
                                )
                            ) : (
                                <p>
                                    {item?.Text?.length > 200
                                        ? item.Text.slice(0, 200) + "..."
                                        : item?.Text}
                                </p>
                            )}

                            <div className='btn-container'>
                                <div className='simple-arrow-btn'>
                                    {item?.Button[0]?.button_text}
                                    <span className='ani_arrows'>
                                        <span className='arrow_arrow'><svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                            <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                                        </svg></span>
                                        <span className='arrow_arrow'><svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                            <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                                        </svg></span>
                                    </span>
                                </div>
                            </div>
                        </Link>
                    ) : (
                        <a href={`https://backend.bgzurlinden.ch${item?.PDF[0]?.PDF?.url}`} download target="_blank" rel="noopener noreferrer" className='item_inner'>
                            <img src={`https://backend.bgzurlinden.ch${item?.icon?.url}`} className='icon-size' alt='#' />

                            {item?.Komponente === "Page" ? (
                                <h4 className="text-darkgrey fw-550">{item?.Bannerbereich[0]?.Titel}</h4>
                            ) : (
                                <h4 className="text-darkgrey fw-550">{item?.Titel}</h4>
                            )}

                            {item?.Komponente === "Page" ? (
                                Array.isArray(item.Bannerbereich[0]?.Beschreibung) ? (
                                    <p>{truncateBlocks(item.Bannerbereich[0]?.Beschreibung, 90)}</p>
                                ) : (
                                    <p>
                                        {item?.Bannerbereich[0]?.Beschreibung?.length > 100
                                            ? item.Bannerbereich[0].Beschreibung.slice(0, 100) + "..."
                                            : item?.Bannerbereich[0]?.Beschreibung}
                                    </p>
                                )
                            ) : (
                                <p>
                                    {item?.Text?.length > 100
                                        ? item.Text.slice(0, 100) + "..."
                                        : item?.Text}
                                </p>
                            )}
                            <div className='btn-container'>
                                <div className='simple-arrow-btn'>
                                    {item?.PDF[0]?.button_text}
                                    <span className='ani_arrows'>
                                        <span className='arrow_arrow'><svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                            <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                                        </svg></span>
                                        <span className='arrow_arrow'><svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                            <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                                        </svg></span>
                                    </span>
                                </div>
                            </div>
                        </a>
                    )}
                </div>
            ))}

            {/* <div className='col-sm-6 col-lg-4 col-item'>
                <div className='item_inner'>
                    <img src='images/wohnen-dok-icon1.svg' className='icon-size' alt='#' />
                    <h4 className="text-darkgrey fw-550">Anmeldung Mietinteresse Wohnung</h4>
                    <p>Sie sind an einer Wohnung in einer Siedlung der Baugenossenschaft Zurlinden (BGZ) interessiert? Dann senden Sie uns Ihre Anmeldung. </p>
                    <div className='btn-container'>
                        <Link className='button simple-arrow-btn'>
                            zur Anmeldung
                            <svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                            </svg>
                        </Link>
                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default Formulare